module.exports = "/_next/static/images/3e0f7198907db35e13d7ad294a3e3402-circles.svg";